import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.128 2.68C4.088 2.682 3.247 3.525 3.247 4.564L3.264 19.624c0.001 1.039 0.846 1.882 1.885 1.88l4.705 -0.006c1.04 0 1.882 -0.844 1.88 -1.885L11.718 4.556c0 -1.04 -0.844 -1.882 -1.885 -1.88l-4.705 0.004Zm0.003 1.883 4.705 -0.006 0.017 15.059 -4.705 0.004 -0.017 -15.058Zm10.351 -1.895c-1.04 0.001 -1.882 0.846 -1.88 1.885l0.017 15.059c0 1.039 0.844 1.88 1.883 1.88l4.707 -0.006c1.039 -0.001 1.88 -0.846 1.88 -1.885l-0.017 -15.059c-0.001 -1.039 -0.846 -1.88 -1.885 -1.88l-4.705 0.006Zm0.001 1.883L20.188 4.546l0.017 15.058 -4.705 0.006 -0.017 -15.058Z"
      fill={fill}
    />
  </g>
);

export default Icon;
